import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';

import types, {transactionsReducerKey} from './types';
import {Action, handleAsyncActions} from '../helpers';

import {transactionsTypes} from '.';
import {synchronizationsTypes} from 'redux/synchronizations';

export const transactionsInitialState = {
   isFetching: false,
   error: null,
   isSubmitting: false,
   // transactions: {} as transactions, // TODO need to replace from layout reducer
};

const reducer = (_state = transactionsInitialState, action: Action) => {
   const state = handleAsyncActions(_state, action, types);

   switch (action.type) {
      // case pageTypes.UPDATE_TRANSACTION.SAGA:
      // case transactionsTypes.VALIDATE_TRANSACTION.SAGA:
      case transactionsTypes.UPDATE_TRANSACTION.REQUEST:
      case transactionsTypes.VALIDATE_TRANSACTION.REQUEST:
      case synchronizationsTypes.UPDATE_SYNCHRONIZATION.REQUEST:
      case synchronizationsTypes.VALIDATE_SYNCHRONIZATION.REQUEST:
         return {
            ...state,
            isSubmitting: true,
         };

      case transactionsTypes.UPDATE_TRANSACTION.ERROR:
      case transactionsTypes.VALIDATE_TRANSACTION.ERROR:
      case synchronizationsTypes.UPDATE_SYNCHRONIZATION.ERROR:
      case synchronizationsTypes.VALIDATE_SYNCHRONIZATION.ERROR:
         return {
            ...state,
            error: action.payload,
            isSubmitting: false,
         };
      case synchronizationsTypes.VALIDATE_SYNCHRONIZATION.SUCCESS:
      case synchronizationsTypes.UPDATE_SYNCHRONIZATION.SUCCESS:
      case transactionsTypes.VALIDATE_TRANSACTION.SUCCESS:
      case transactionsTypes.UPDATE_TRANSACTION.SUCCESS:
         return {
            ...state,
            error: null,
            isSubmitting: false,
         };

      default:
         return state;
   }
};

let _reducer = reducer;
if (process.env.REACT_APP_PERSISTED === 'true') {
   const config = {
      key: transactionsReducerKey,
      storage: storage,
      blacklist: ['error', 'isFetching'],
   };
   _reducer = persistReducer(config, reducer) as any;
}
export default _reducer;
